import type { VerifiedBotStatus } from '../types'

/**
 * Gets the verified bot status from the meta tag in the document.
 *
 * Looks for a meta tag with name="verifiedbot" and reads its content attribute.
 * The content should be either "true" or "false" to indicate if the request
 * is from a verified bot.
 *
 * @returns {VerifiedBotStatus} - Returns "true" or "false" if the meta tag has
 *                                 valid content, otherwise returns "unknown"
 */
export function getVerifiedBot(): VerifiedBotStatus {
  const allowedStatuses = ['true', 'false']
  const verifiedbotValue = document
    .querySelector('meta[name="verifiedbot"]')
    ?.getAttribute('content')
  if (
    typeof verifiedbotValue === 'string' &&
    allowedStatuses.includes(verifiedbotValue)
  ) {
    return verifiedbotValue as VerifiedBotStatus
  }

  return 'unknown'
}
